import { createSlice } from "@reduxjs/toolkit";

type Payload = {
  startDate: string | null;
  endDate: string | null;
};

type State = {
  payload: Payload;
};

const slice = createSlice({
  name: "sortDates",
  initialState: { payload: { startDate: "", endDate: "" } } as State,
  reducers: {
    getSortDates: (state, { payload }: { payload: Payload }) => {
      state.payload = payload;
    }
  }
});

export const { getSortDates } = slice.actions;
export default slice.reducer;
